import { useCallback, useState } from 'react';
import { CalendarService } from '@services/requests/housien-services/CalendarService';

export type UseGoogleSyncReturn = {
  sync: () => Promise<void>;
  isSyncing: boolean;
  error: boolean;
};

/**
 * Triggers incremental Google Calendar import on the backend.
 */
export const useGoogleSync = (agencyId: string): UseGoogleSyncReturn => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [error, setError] = useState(false);

  const sync = useCallback(async () => {
    setError(false);
    setIsSyncing(true);
    try {
      await CalendarService.syncGoogle(agencyId);
    } catch {
      setError(true);
      throw new Error('google_sync_failed');
    } finally {
      setIsSyncing(false);
    }
  }, [agencyId]);

  return { sync, isSyncing, error };
};
